import Image, { StaticImageData } from '../image';
import Link from 'next/link';

interface IDescCardProps {
  title: string;
  imageUrl?: string | StaticImageData;
  desc: string;
  className?: string;
  linkHref?: string;
}

export const DescCard: React.FC<IDescCardProps> = ({
  imageUrl,
  title,
  desc,
  className = '',
  linkHref,
}) => {
  const content = (
    <div className={`flex-1 ${className}`}>
      <div className="bg-white h-full rounded-lg flex items-center justify-center p-[30px] flex-col flex-box mobile:py-5 mobile:rounded-md mobile:px-[10px]">
        <Image
          src={imageUrl || ''}
          width={40}
          height={40}
          alt="图片"
          className="h-10 w-10"
        />
        <div className="mt-[10px] mb-2 text-base text-center text-primary -leading-[1px] line-clamp-1 mobile:text-sm mobile:mb-[6px] font-500 flex item-center whitespace-nowrap w-full justify-center">
          {title}
        </div>
        <p className="text-primary text-sm text-primary/[.6] line-clamp-3 flex-1 mobile:text-xs text-center font-400">
          {desc}
        </p>
      </div>
    </div>
  );
  if (linkHref) {
    return (
      <Link href={linkHref} target="_blank" className="flex-1">
        {content}
      </Link>
    );
  }
  return content;
};
